import { forwardRef, InputHTMLAttributes } from 'react'
import { cn } from '@/lib/utils'
import { useHasRedesign } from '@/utils/redesignSellers'

/* Igual que el botón: los sellers sin rediseño (ver REDESIGN_SELLERS) tienen que seguir
   viendo el input como lo dibujaba NextUI —variante "flat": fondo gris suave, más alto y
   con esquinas redondeadas— en vez del campo de línea fina del rediseño. */
const REDESIGN_CLASSES = 'h-8 rounded-lg border border-input bg-transparent px-2.5 py-1 text-sm transition-colors placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50'
const LEGACY_CLASSES = 'h-10 rounded-xl border-0 bg-default-100 hover:bg-default-200 focus:bg-default-100 px-3 py-1 text-sm transition-background placeholder:text-default-500'

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, type, ...props }, ref) => {
    const hasRedesign = useHasRedesign()

    return (
      <input
        ref={ref}
        type={type}
        data-slot='input'
        className={cn(
          'w-full min-w-0 outline-none disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
          hasRedesign ? REDESIGN_CLASSES : LEGACY_CLASSES,
          className
        )}
        {...props}
      />
    )
  }
)
Input.displayName = 'Input'
